// extracted by mini-css-extract-plugin
module.exports = {"banner_mango":"BannerMango_banner_mango__ckQt8","banner_mango__desc":"BannerMango_banner_mango__desc__IgI_0"};